import { atom } from "recoil";
import { RecoilKeys } from "./keyDefinitions";

export type BizsolDisconnectModalState = {
  step: number;
  temporaryPassword: string;
};

export const bizsolDisconnectModalState = atom<BizsolDisconnectModalState>({
  key: RecoilKeys.BizsolDisconnectModalState,
  default: { step: 1, temporaryPassword: "" },
});
